import { object, string } from "yup";
import { ESTADOS_CIVILES } from "../../../../constants/contexts";

export const FormikInitialValues = {
	valor: "",
	contexto: ESTADOS_CIVILES,
}

export const FormikValidationSchema = object().shape({
	valor: string()
		.min(3, ({ min }) => `El estado civil debe tener al menos ${min} caracteres.`)
		.max(200, ({ max }) => `El estado civil debe tener a lo más ${max} caracteres.`)
		.required("El estado civil es requerido."),
});